<script>

  import {mapActions, mapGetters} from 'vuex';

  import headerUtils from './HeaderUtils';
  import utilsService from 'src/services/UtilsService';

  export default {
    props: ['meuCollapse'],
    data: function() {
      return {
        menus: []
      }
    },
    computed: {
      ...mapGetters([
        'userLoggedRoles'
      ])
    },
    mounted: function() {
      headerUtils.resolveContractMenu(this.$route.params).then((response) => {
        this.buildMenu(this.userLoggedRoles, response.menu, this.menus);
      });
    },
    methods: {
      buildMenu: function(roles, menuSource, menuTarget) {

        menuSource.map(it => {

          let menuItem = {
            id: it.id,
            labelPt: it.labelPt,
            type: it.type,
            formId: it.formId ? it.formId : null,
            childs: [],
            form: {
              availableInMobile: it.form.availableInMobile,
              availableInWeb: it.form.availableInWeb
            }
          };

          this.buildMenu(roles, it.childs, menuItem.childs);

          if (menuItem.type == 'FORM' && utilsService.hasRole(roles, it.formId) && it.form.availableInWeb) {
            menuTarget.push(menuItem);
          } else if (menuItem.childs.length > 0) {
            menuTarget.push(menuItem);
          }
        });
      },
      toggleUserMenu(menu) {
        if (this.menuActive != menu.id) {
          this.menuActive = menu.id;
        } else {
          this.menuActive = '';
        }
      },
      openNivel: function(id) {
        let className = document.getElementById(id).parentElement.className;
        if (className.indexOf("open") > -1) {
          document.getElementById(id).parentElement.className = "dropdown";
        } else {
          document.getElementById(id).parentElement.className = "dropdown open";
        }
      }
    }
  }


</script>

<template>
  <div>
    <ul class="nav navbar-nav">
      <li class="dropdown" v-for="menu in menus">
        <a href="javascript:;" @click="openNivel(menu.id)" :id="menu.id">{{menu.labelPt}}</a>

        <ul class="dropdown-menu">
          <li class="dropdown" v-for="row in menu.childs">
            <template v-if="row.type == 'NO_LINK'">
              <a href="javascript:;" @click="openNivel(row.id)" :id="row.id">{{row.labelPt}}</a>
            </template>
            <template v-else>
              <router-link :to="{ name: 'ModuleList', params: { formId: row.formId } }" exact>
                {{row.labelPt}}
              </router-link>
            </template>
            <ul class="dropdown-menu dropdown-menu-text-indent-20px">
              <li class="dropdown" v-for="row2 in row.childs">
                <template v-if="row2.type == 'NO_LINK'">
                  <a href="javascript:;" @click="openNivel(row2.id)" :id="row2.id">{{row2.labelPt}}</a>
                </template>
                <template v-else>
                  <router-link :to="{ name: 'ModuleList', params: { formId: row2.formId } }" exact>
                    {{row2.labelPt}}
                  </router-link>
                </template>
                <ul class="dropdown-menu dropdown-menu-text-indent-40px">
                  <li class="dropdown" v-for="row3 in row2.childs">
                    <router-link :to="{ name: 'ModuleList', params: { formId: row3.formId } }" exact>
                      {{row3.labelPt}}
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <!--
    <ul class="menu root">
      <li v-for="menu in menus">
        <a href="javascript:;">{{menu.labelPt}}</a>
        <ul class="submenu submenu-1">
          <li v-for="row in menu.childs">
            <template v-if="row.type == 'NO_LINK'">
              <a href="javascript:;">{{row.labelPt}}</a>
            </template>
            <template v-else>
              <router-link :to="{ name: 'ModuleList', params: { formId: row.formId } }" exact>
                {{row.labelPt}}
              </router-link>
            </template>
            <ul class="submenu submenu-2">
              <li v-for="row2 in row.childs">
                <template v-if="row2.type == 'NO_LINK'">
                  <a href="javascript:;">{{row2.labelPt}}</a>
                </template>
                <template v-else>
                  <router-link :to="{ name: 'ModuleList', params: { formId: row2.formId } }" exact>
                    {{row2.labelPt}}
                  </router-link>
                </template>
                <ul class="submenu submenu-3">
                  <li v-for="row3 in row2.childs">
                    <template v-if="row3.type == 'NO_LINK'">
                      <a href="javascript:;">{{row3.labelPt}}</a>
                    </template>
                    <template v-else>
                      <router-link :to="{ name: 'ModuleList', params: { formId: row3.formId } }" exact>
                        {{row3.labelPt}}
                      </router-link>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    -->

  </div>
</template>

<style scoped>
  .dropdown-menu-text-indent-20px{
    text-indent: 20px;
  }
  .dropdown-menu-text-indent-40px{
    text-indent: 40px;
  }
</style>






// WEBPACK FOOTER //
// subMenuResponsive.vue?3f71e512